import _styled from "styled-components";
const _excluded = ["value", "selecting", "placeholder", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const StyledDiv = styledC.div.withConfig({
  displayName: "FieldValue__StyledDiv",
  componentId: "sc-1734kqa-0"
})(["display:flex;padding:", "px ", "px;align-items:center;outline:none;border-radius:", "px;background-color:", ";color:", ";", ""], theme.spacing.XXXS, theme.spacing.XXS, theme.borderRadius.medium, props => props.$selecting ? theme.tokens.colors.background.focused.value : 'transparent', props => props.value && !props.disabled ? theme.tokens.colors.text.primary.value : theme.tokens.colors.text.inactive.value, theme.typography.labelMedium);
var _StyledStyledDiv = styledC(StyledDiv).withConfig({
  displayName: "FieldValue___StyledStyledDiv",
  componentId: "sc-1734kqa-1"
})(["", ""], p => p.$_css);
const FieldValue = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      value,
      selecting,
      placeholder,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledStyledDiv, _extends({
    ref: ref,
    value: value,
    $selecting: selecting
  }, props, {
    $_css: style
  }), value || placeholder);
});
FieldValue.displayName = 'FieldValue';
FieldValue.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to display, should be the formatted date(s) string(s) */
  value: PropTypes.any,
  /** Whether the field is selecting the date */
  selecting: PropTypes.bool,
  /** Placeholder to display when there is no value */
  placeholder: PropTypes.string,
  /** Whether the field is disabled */
  disabled: PropTypes.bool
};
export default FieldValue;
//# sourceMappingURL=FieldValue.js.map